/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

export function plotWaterfallChart({ waterfallChartRefs, waterfallChartPanelRefs, networkData }) {
  if (!waterfallChartPanelRefs) return;

  waterfallChartPanelRefs.style.display = 'block';

  if (!(networkData.autoEvalScore && networkData.autoEvalScore.barMetrics)) {
    waterfallChartPanelRefs.style.display = 'none';
    return;
  }

  const data = Object.entries(networkData.autoEvalScore.barMetrics).map(([label, value]) => ({ label: formatLabel(label), value: value / 100 }));
  const firstBar = data.shift();
  const totalBar = data.find((item) => item.label === 'Total');
  data.splice(data.findIndex((item) => item.label === 'Total'), 1);

  data.sort((a, b) => b.value - a.value);

  const sortedData = [firstBar, ...data, totalBar];

  const xVal = sortedData.map((item) => item.label);
  const yVal = sortedData.map((item) => item.value);

  yVal[yVal.length - 1] = 1;

  const baseTrace = {
    x: xVal.slice(0, xVal.length - 1),
    y: yVal.slice(0, yVal.length - 1).reduce(
      (acc, curr) => {
        acc.push(acc[acc.length - 1] + curr);
        return acc;
      },
      [0]
    ),
    marker: {
      color: 'rgba(1,1,1,0.0)',
    },
    type: 'bar',
    hoverinfo: 'none',
  };

  const barTrace = {
    x: xVal,
    y: yVal,
    marker: {
      color: this.waterfallChartBarColors,
    },
    text: yVal.map((item) => {
      if (item == 1) return '100';
      if (Number(item) <= 0.001) return '< 0.1';
      return (Number(item) * 100).toFixed(1);
    }),
    textposition: 'outside',
    type: 'bar',
    hoverinfo: 'none',
  };

  var traceData = [baseTrace, barTrace];

  var layout = {
    barmode: 'stack',
    paper_bgcolor: 'rgba(245,246,249,1)',
    plot_bgcolor: 'rgba(245,246,249,1)',
    showlegend: false,
    margin: { pad: 8, t: 40 },
    bargap: 0.5,
    width: 0.15,
    xaxis: {
      fixedrange: true,
      tickfont: {
        size: 12,
        family: 'Helvetica',
      },
    },
    yaxis: {
      side: 'left',
      fixedrange: true,
      showticklabels: false,
      title: {
        text: 'Impact',
        font: {
          size: 12,
          color: '#000000',
          family: 'Helvetica',
        },
      },
    },
  };

  if (waterfallChartRefs) {
    // eslint-disable-next-line no-undef
    Plotly.newPlot(waterfallChartRefs, traceData, layout, { responsive: true, displayModeBar: false });
    this.calculateWaterfallHrLine();
  }
}

export function formatLabel(label) {
  const breakMap = {
    'User Abandoned': 'User<br>Abandoned',
    'Escalation not Connected': 'Escalation<br>not<br>Connected',
    'Repeated Escalation Requested': 'Repeated<br>Escalation<br>Requests',
    'Live Agent Escalation': 'Escalation',
    'Negative Feedback': 'Negative<br>Feedback',
    'False Positives': 'False<br>Positives',
    'Bad Containment': 'Bad<br>Containment',
    'Negative Sentiment': 'Negative<br>Sentiment',
    'Bot Repetition': 'Bot<br>Repetition',
    'User Paraphrases': 'User<br>Paraphrases',
  };

  if (breakMap[label]) return breakMap[label];
  return label;
}
